/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Header_Full_BreakdownInputs */

const en_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full breakdown`)
};

const zh_hans1_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整数据`)
};

const pt_br2_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhamento completo`)
};

const es_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose completo`)
};

const fr_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détail complet`)
};

const de_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Details`)
};

const ru_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная разбивка`)
};

const it_platform_header_full_breakdown = /** @type {(inputs: Platform_Header_Full_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettaglio completo`)
};

/**
* | output |
* | --- |
* | "Full breakdown" |
*
* @param {Platform_Header_Full_BreakdownInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_header_full_breakdown = /** @type {((inputs?: Platform_Header_Full_BreakdownInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Header_Full_BreakdownInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_header_full_breakdown(inputs)
	if (locale === "pt-BR") return pt_br2_platform_header_full_breakdown(inputs)
	if (locale === "es") return es_platform_header_full_breakdown(inputs)
	if (locale === "fr") return fr_platform_header_full_breakdown(inputs)
	if (locale === "de") return de_platform_header_full_breakdown(inputs)
	if (locale === "ru") return ru_platform_header_full_breakdown(inputs)
	if (locale === "it") return it_platform_header_full_breakdown(inputs)
	return en_platform_header_full_breakdown(inputs)
});